import React from 'react';
import { createContext, useContext, useState } from 'react';
import { configs } from '../../assets/Config';
import { createOrderLeadRmeark, createUpdateRemark, createUpdateRemarkNonUser, editOrderLeadRmeark, getAllLatestRemark, getAllLatestRemarkByRM, getAllLatestRemarkByUser, getAllRemark, getNoRMUser } from '../apis/CRMApi';
import { useLogin } from './AdminLoginContext';

// create global news management context
export const CRMContext = createContext();

export function CRMProvider({ children }) {

    const { token, logout, setLoginError } = useLogin();

    const [remarkList, setRemarkList] = useState("")
    const [editRemark, setEditRemark] = useState(false)
    const [editRemarkData, setEditRemarkData] = useState({})
    const [showDeletedRemark, setShowDeletedRemark] = useState(false)
    const [remarkListType, setRemarkListType] = useState("")

    const [page, setPage] = useState(configs.startPage);
    const [customer, setCustomer] = useState("")
    const [relationshipManager, setRelationshipManager] = useState({})

    // get all latest remark list
    async function getAllLatestRemarkList(page, size, replace) {
        try {
            let response = await getAllLatestRemark(token, page, size === configs.allRecordsFetchedTillNow ? remarkList.length + configs.startPage : size);
            if (response && response.status === 200) {
                replace ? setRemarkList(response.data) : setRemarkList([...remarkList, ...response.data])
            } else if (response && response.status === 401) {
                logout()
                setLoginError(configs.unauthorizedErrorMessage)
            } else {
                setRemarkList("")
            }
        } catch (error) {

        }
    }

    // get all remark list
    async function getAllRemarkList(url, page, size, replace) {
        try {
            let response = await getAllRemark(token, url, page, size === configs.allRecordsFetchedTillNow ? remarkList.length + configs.startPage : size);
            if (response && response.status === 200) {
                replace ? setRemarkList(response.data) : setRemarkList([...remarkList, ...response.data])
            } else if (response && response.status === 401) {
                logout()
                setLoginError(configs.unauthorizedErrorMessage)
            } else {
                setRemarkList("")
            }
        } catch (error) {

        }
    }

    // get no rm users list
    async function getNoRMUserList() {
        try {
            let response = await getNoRMUser(token);
            if (response && response.status === 200) {
                setRemarkList(response.data)
            } else if (response && response.status === 401) {
                logout()
                setLoginError(configs.unauthorizedErrorMessage)
            } else {
                setRemarkList([])
            }
        } catch (error) {

        }
    }

    // get all remark by rm
    async function getAllRemarkListByRM(adminId, page, size, replace) {
        try {
            let response = await getAllLatestRemarkByRM(token, adminId, page, size === configs.allRecordsFetchedTillNow ? remarkList.length + configs.startPage : size);
            if (response && response.status === 200) {
                replace ? setRemarkList(response.data) : setRemarkList([...remarkList, ...response.data])
            } else if (response && response.status === 401) {
                logout()
                setLoginError(configs.unauthorizedErrorMessage)
            } else {
                setRemarkList([])
            }
        } catch (error) {

        }
    }

    // get all remark list by user
    async function getAllRemarkListByUser(userId, page, size, replace, getRecords) {
        try {
            let response = await getAllLatestRemarkByUser(token, userId, page, size === configs.allRecordsFetchedTillNow ? remarkList.length + configs.startPage : size);
            if (response && response.status === 200) {
                setRelationshipManager(response.data && response.data[0] && response.data[0].relationship_manager ? response.data[0].relationship_manager : {})
                if (getRecords)
                    replace ? setRemarkList(response.data) : setRemarkList([...remarkList, ...response.data])
            } else if (response && response.status === 401) {
                logout()
                setLoginError(configs.unauthorizedErrorMessage)
            } else {
                setRemarkList([])
            }
        } catch (error) {
            console.error(error);
        }
    }

    // create or update news
    async function createEditRemark(userId, lastCallDate, remark, comapnyId, custSegment, followUpDate, interested_in, relationship_manager,) {
        try {
            let response = await createUpdateRemark(token, userId, relationship_manager, lastCallDate, remark, comapnyId, custSegment, followUpDate, interested_in, editRemark);
            if (response && response.status === 200) {
                return "success"
            } else if (response && response.status === 401) {
                logout()
                setLoginError(configs.unauthorizedErrorMessage)
            } else {
                return response.data.error
            }
        } catch (error) {
            console.error(error);
        }
    }


    // create or update remark for non existing user
    async function createEditRemarkNonUser(name, email, mobile, lastCallDate, remark, investable_surplus, interested_in, relationship_manager) {
        try {
            let response = await createUpdateRemarkNonUser(token, name, email, mobile, relationship_manager, lastCallDate, remark, investable_surplus, interested_in, editRemark);
            if (response && response.status === 200) {
                return "success"
            } else if (response && response.status === 401) {
                logout()
                setLoginError(configs.unauthorizedErrorMessage)
            } else {
                return response.data.error
            }
        } catch (error) {

        }
    }


    // create order lead
    async function createOrderLead(customerId, name, email, mobile, companyName, Quantity, rate, cQuote, oQuote, aQuote, orderType, remark, editRemark, company_id) {
        try {
            let response = await createOrderLeadRmeark(token, customerId, name, email, mobile, companyName, Quantity, rate, cQuote, oQuote, aQuote, orderType, remark, editRemark, company_id);
            if (response && response.status === 200) {
                return "success"
            } else if (response && response.status === 401) {
                logout()
                setLoginError(configs.unauthorizedErrorMessage)
            } else {
                return response.data.error
            }
        } catch (error) {
            console.error(error);

        }
    }

    // edit order lead
    async function editOrderLead(insightId, status, cQuote, oQuote, aQuote, remark, quantity, order_type) {
        try {
            let response = await editOrderLeadRmeark(token, insightId, status, cQuote, oQuote, aQuote, remark, quantity, order_type);
            if (response && response.status === 200) {
                return "success"
            } else if (response && response.status === 401) {
                logout()
                setLoginError(configs.unauthorizedErrorMessage)
            } else {
                return response.data.error
            }
        } catch (error) {

        }
    }

    async function getRemarkByRemarkType(remarkListType, replace, recordPerPage, userDetail = "", getRecords) {
        try {
            if (remarkListType && (configs.crm_insights[remarkListType] || configs.crm_order_insights[remarkListType]) && page) {
                if (remarkListType === Object.keys(configs.crm_insights)[1])
                    await getAllLatestRemarkList(replace ? configs.startPage : page, recordPerPage === 0 ? 0 : recordPerPage === configs.allRecordsFetchedTillNow ? configs.allRecordsFetchedTillNow : configs.recordPerPage, replace)
                else if (remarkListType === Object.keys(configs.crm_insights)[2])
                    await getAllRemarkListByUser(userDetail && userDetail.id ? userDetail.id : customer && customer.id ? customer.id : "", replace ? configs.startPage : page, recordPerPage === 0 ? 0 : recordPerPage === configs.allRecordsFetchedTillNow ? configs.allRecordsFetchedTillNow : configs.recordPerPage, replace, getRecords)
                else if (remarkListType === Object.keys(configs.crm_insights)[3])
                    await getAllRemarkListByRM(userDetail && userDetail.id ? userDetail.id : relationshipManager && relationshipManager.id ? relationshipManager.id : "", replace ? configs.startPage : page, recordPerPage === 0 ? 0 : recordPerPage === configs.allRecordsFetchedTillNow ? configs.allRecordsFetchedTillNow : configs.recordPerPage, replace)
                else if (remarkListType === Object.keys(configs.crm_insights)[4])
                    await getNoRMUserList(replace ? configs.startPage : page, recordPerPage === 0 ? 0 : recordPerPage === configs.allRecordsFetchedTillNow ? configs.allRecordsFetchedTillNow : configs.recordPerPage, replace)
                else {
                    await getAllRemarkList(remarkListType === Object.keys(configs.crm_insights)[0] ? "" : remarkListType === Object.keys(configs.crm_order_insights)[0] ? "order-insight" : `order-insight/status/${remarkListType}`, replace ? configs.startPage : page, recordPerPage === 0 ? 0 : recordPerPage === configs.allRecordsFetchedTillNow ? configs.allRecordsFetchedTillNow : configs.recordPerPage, replace)
                }

            }
        } catch (error) {
            console.error(error);

        }
    }

    // export global context
    return (
        <CRMContext.Provider
            value={{
                remarkList,
                setRemarkList,
                getAllLatestRemarkList,
                getAllRemarkListByUser,
                editRemark,
                setEditRemark,
                editRemarkData,
                setEditRemarkData,
                createEditRemark,
                createEditRemarkNonUser,
                showDeletedRemark,
                setShowDeletedRemark,
                getAllRemarkList,
                getNoRMUserList,
                getAllRemarkListByRM,
                remarkListType,
                setRemarkListType,
                createOrderLead,
                editOrderLead,
                getRemarkByRemarkType,
                page,
                setPage,
                customer,
                setCustomer,
                relationshipManager,
                setRelationshipManager,
            }}
        >
            {children}
        </CRMContext.Provider>
    );
}

// return news management context
export function useCRMContext() {
    return useContext(CRMContext);
}